import { ButtonLink } from '@design';
import { config } from '@terminal/config';
import React, { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { WatchlistManagerName } from '../watchlist-manager-name/WatchlistManagerName';
import styles from './WatchlistManagerHeader.module.scss';

export interface WatchlistManagerHeaderProps {
  listName: string;
  isRenameActive: boolean;
  onUpdateName: (name: string) => void;
  setIsRenameActive: Dispatch<SetStateAction<boolean>>;
  hasEntities: boolean;
  hasInputError: boolean;
  activeListName?: string;
}

export const WatchlistManagerHeader = (props: WatchlistManagerHeaderProps) => {
  const { t } = useTranslation(['watchlistManager']);

  const openNameInput = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    props.setIsRenameActive(true);
  };

  return (
    <div className={styles.root}>
      <WatchlistManagerName {...props} openNameInput={openNameInput} />
      <p className={styles.description}>
        {t('watchlistManager:description')}
      </p>
      <ButtonLink
        className={styles.styledButtonLink}
        label={
          <a
            href={config.urls.helpImportWatchlist}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>{t('watchlistManager:howToImport')}</span>
          </a>
        }
        iconName="QuestionMarkFill"
        iconSize={14}
      />
    </div>
  );
};
